import { Roles } from "../../../constants/roles";
import { FormBase } from "../../../util/form-base-form";

class SearchProductUpdatedByPickerFormBase extends FormBase {
    public override queryElement<T extends Element = HTMLElement>(
        root: ParentNode | null | undefined,
        selector: string,
        elementClass?: abstract new (...args: never[]) => T,
    ): T | null {
        return super.queryElement(root, selector, elementClass);
    }
}

const formBase = new SearchProductUpdatedByPickerFormBase();

export class SearchProductUpdatedByPickerForm {
    public static getPickerRoot(root: ParentNode): HTMLElement | null {
        return formBase.queryElement(root, `[data-role="${Roles.SEARCH_PRODUCT_UPDATED_BY_PICKER}"]`, HTMLElement);
    }

    public static getChips(root: ParentNode): HTMLElement | null {
        return formBase.queryElement(root, `[data-role="${Roles.SEARCH_PRODUCT_UPDATED_BY_CHIPS}"]`, HTMLElement);
    }
}
